import { render } from "./management.cattle.io.oidcclient.vue?vue&type=template&id=22c45054&ts=true"
import script from "./management.cattle.io.oidcclient.vue?vue&type=script&lang=ts"
export * from "./management.cattle.io.oidcclient.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../Users/onchainengineer/workbench/sourcecode/github_autonomy-cloud/dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__